import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorMessage: error.message || "Unknown error" };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught in ErrorBoundary: ", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render the fallback UI along with the error message
      return (
        <center>
          <br />
          <h1>Something went wrong.</h1>
          <p>{this.state.errorMessage}</p>
        </center>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
